/* Copyright */
import { ConnectivityUnitHWStateProperties } from "../ConnectivityUnitHW/ConnectivityUnitHWStateProperties";
export class GateUnitHWStateProperties extends ConnectivityUnitHWStateProperties {
    constructor(properties) {
        var _a;
        super(properties);
        this.radioConnected = (_a = properties.radioConnected) !== null && _a !== void 0 ? _a : null;
    }
}
